import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

/**
 * A consistently-styled status pill used across invoice and RCTI tables.
 *
 * Props:
 *  - label        {string}   Main status text (required)
 *  - pillClass    {string}   Tailwind bg + text color classes (required)
 *  - subLabel     {string}   Optional second line, shown in parentheses
 *  - showError    {boolean}  When true, shows an error icon before the label
 *  - onClick      {func}     Optional click handler; makes the pill cursor-pointer
 */
const StatusPill = ({ label, pillClass, subLabel, showError, onClick }) => {
  // Use w-max to ensure the background fully hugs the content without stretching awkwardly when text wraps
  const base = `px-2 py-1 inline-block w-max text-left text-xs font-semibold rounded-full leading-5${onClick ? ' cursor-pointer' : ''}`;

  if (subLabel) {
    // Two-line variant — inline-flex flex-col so the parenthetical wraps beneath
    return (
      <span
        className={`px-2 py-1 inline-flex flex-col w-max items-start text-left text-xs font-semibold rounded-full leading-5${onClick ? ' cursor-pointer' : ''} ${pillClass}`}
        onClick={onClick}
      >
        <span className="flex items-center">
          {showError && <FaExclamationCircle className="mr-1" />}
          {label}
        </span>
        <span>({subLabel})</span>
      </span>
    );
  }

  return (
    <span className={`${base} ${pillClass}`} onClick={onClick}>
      {showError && <FaExclamationCircle className="mr-1 inline" />}
      {label}
    </span>
  );
};

export default StatusPill;
